(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-collection-style"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  console.log('Featured Width JavaScript loaded');
  
  // Use generic selectors that don't rely on section ID
  const products1 = document.querySelectorAll('a[class*="product-block"]');
  const products2 = document.querySelectorAll('a[class*="fc-"]');
  const products3 = document.querySelectorAll('.collection a');
  
  console.log('Found', products1.length, 'products with product-block selector');
  console.log('Found', products2.length, 'products with fc- selector');
  console.log('Found', products3.length, 'products with collection a selector');
  
  // Use the first selector that finds products
  const products = products1.length > 0 ? products1 : (products2.length > 0 ? products2 : products3);
  console.log('Using', products.length, 'products for touch events');

  products.forEach(function(product, index) {
    console.log('Processing product', index + 1, 'with classes:', product.className);
    
    // Try multiple selectors for images
    const mainImage = product.querySelector('img[class*="main"]') ||
                     product.querySelector('img[class*="image-main"]') ||
                     product.querySelector('img:first-child');
    const hoverImage = product.querySelector('img[class*="hover"]') ||
                      product.querySelector('img[class*="image-hover"]') ||
                      product.querySelector('img:nth-child(2)');
    const variants = product.querySelectorAll('[class*="variant"]');
    
    console.log('Product', index + 1, '- Main image:', !!mainImage, 'Hover image:', !!hoverImage);
    
    // Mobile hover is now handled by CSS :active state - no JavaScript needed

    // Variant functionality (if variants exist)
    variants.forEach(function(variant) {
      // Mouse events for desktop
      variant.addEventListener('mouseover', function() {
        mainImage.src = variant.dataset.img;
      });
      variant.addEventListener('mouseout', function() {
        mainImage.src = mainImage.dataset.original;
      });
      
      // Touch events for mobile variants
      variant.addEventListener('touchstart', function(e) {
        e.preventDefault();
        mainImage.src = variant.dataset.img;
      });
      
      variant.addEventListener('touchend', function(e) {
        e.preventDefault();
        setTimeout(function() {
          mainImage.src = mainImage.dataset.original;
        }, 1000);
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
